<template>
  <div>
    <b>General description</b>
    <br />
    This mission computes the cost and duration for a deorbitation manoeuvre
    analytically. It is performed by inserting the spacecraft into a 500 km
    circular orbit, which guarantees a reentry in less than 25 years.
    <br />
    The atmosphere model considered is the tabulated US76, which is used to
    compute the atmospheric density between 0 and 1000 km.
    <br />
  </div>
</template>

<script>
export default {
  name: 'tooltipParametricDeorbitation'
}
</script>
